import * as React from 'react';

import styles from './ChatHeaderCard.css';
import { Card } from './components';
import { IHeaderCard } from '../../../types/chatHeader';

export const ChatHeaderCard: React.FC<IHeaderCard> = ({ action, ...rest }) => {
  const { type, url } = action;
  const cardLink = type === 'link' ? url : null;

  return (
    <div className={styles['container']} data-testid="chat_header_card">
      {cardLink ? (
        <a className={styles['card-link']} href={cardLink} target="_blank" rel="noreferrer">
          <Card {...rest} />
        </a>
      ) : (
        <Card {...rest} />
      )}
    </div>
  );
};
